import { LitElement, html } from 'lit';
import { customElement, query } from 'lit/decorators.js';

import awardIcon from '@amityeko/design-system/dist/assets/icons/award';

import '@amityeko/design-system/dist/elements/icon';
import '@amityeko/design-system/dist/elements/dialog';
import '@amityeko/design-system/dist/components/empty-view';

import type AmityekoDialog from '@amityeko/design-system/dist/elements/dialog';

import styles from './styles';

/**
 * @dependency amityeko-icon
 * @dependency amityeko-dialog
 * @dependency amityeko-empty-view
 *
 * @slot default - Element that triggers the dialog with Empty View
 */
@customElement('rnr-badges-empty-view')
export default class RnRBadgesEmptyView extends LitElement {
  static styles = styles;

  @query('#dialog') dialog!: AmityekoDialog;

  private _onClick() {
    this.dialog.show();
  }

  protected render() {
    return html`
      <slot @click=${this._onClick}></slot>

      <amityeko-dialog id="dialog" label="Select Badge">
        <amityeko-empty-view label="No badges here" caption="Badges will be available soon!">
          <amityeko-icon slot="badge-icon">${awardIcon}</amityeko-icon>
        </amityeko-empty-view>
      </amityeko-dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-badges-empty-view': RnRBadgesEmptyView;
  }
}
